module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body-lo"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "lo-modal-title"
  }, [_vm._v("TẠO PC THÀNH CÔNG")]), _c('span', {
    staticClass: "lo-modal-btn-close material-icons",
    on: {
      "click": _vm.redirectPC
    }
  }, [_vm._v("close")])]), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "reg-content"
  }, [_vm._v("Xin chúc mừng! Bạn đã tạo thành công cộng đồng "), _c('span', [_vm._v("“" + _vm._s(_vm.pc_name) + "”.")])]), _c('div', {
    staticClass: "note"
  }, [_vm._v("Bắt đầu chia sẻ kiến thức bằng cách cập nhật thông tin Lý Thuyết và Bài Tập cho cộng đồng và lớp học của bạn.")])]), _c('div', {
    staticClass: "modal-footer lo-custom-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-12 text-center"
  }, [_c('a', {
    staticClass: "lo-btn-continue lo-popup-pc btn",
    on: {
      "click": function($event) {
        return _vm.validateContinute()
      }
    }
  }, [_vm._v("Tiếp tục")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63f57284","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PC/popup.vue
// module id = 1586
// module chunks = 0